import { recommendations } from '@/mocks/russianMom';

export default function RecommendSection() {
  return (
    <section id="recommend" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-magic-line" aria-hidden="true"></i>
              相关推荐
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              看完之后，还可以接着看这些
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              这些作品与《俄罗斯妈妈》在题材或气质上相近，都以家庭、亲情与生活细节为核心。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {recommendations.map((p) => (
            <article
              key={p.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-[220px] w-full overflow-hidden bg-background-200 md:h-[260px]">
                <img
                  src={p.img}
                  alt={`${p.title} 推荐封面`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-sm bg-foreground-950/70 px-1.5 py-0.5 text-[11px] text-background-100 backdrop-blur">
                  {p.meta.split(' · ')[0]}
                </span>
              </div>
              <div className="p-3.5">
                <h3 className="font-heading text-sm font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-1 text-[11px] text-primary-700">{p.meta}</p>
                <p className="mt-2 text-xs leading-6 text-foreground-600">{p.note}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}